// Menu

document.addEventListener('DOMContentLoaded', () => {

  const parents = document.querySelectorAll('.nav-parent[data-toggle="submenu"]');

  function updateBodyOverlay() {
    const anyOpen = document.querySelector('.nav-item.has-children.open');
    document.body.classList.toggle('submenu-open', !!anyOpen);
  }

  parents.forEach(parent => {
    parent.addEventListener('click', (e) => {
      e.preventDefault();

      const clickedItem = parent.parentElement;

      // Close any other open items
      document.querySelectorAll('.nav-item.has-children.open').forEach(item => {
        if (item !== clickedItem) item.classList.remove('open');
      });

      // Toggle clicked one
      clickedItem.classList.toggle('open');

      updateBodyOverlay();
    });
  });

  // Click outside to close
  document.addEventListener('click', (e) => {
    const isInsideMenu = e.target.closest('.nav-item.has-children');
    if (!isInsideMenu) {
      document.querySelectorAll('.nav-item.has-children.open').forEach(item => {
        item.classList.remove('open');
      });

      updateBodyOverlay();
    }
  });

});

// Sub Mneu Images

document.addEventListener('DOMContentLoaded', () => {

  const submenuItems = document.querySelectorAll('.submenu li');

  submenuItems.forEach(item => {

    const img = item.querySelector('.submenu-cycle');
    if (!img) return;

    const imageList = img.dataset.images;
    if (!imageList) return;

    const sources = imageList.split(',').map(s => s.trim());
    let index = 0;
    let interval;

    item.addEventListener('mouseenter', () => {

      if (sources.length <= 1) return;

      interval = setInterval(() => {
        index = (index + 1) % sources.length;
        img.src = sources[index];
      }, 1000);

    });

    item.addEventListener('mouseleave', () => {

      clearInterval(interval);
      index = 0;
      img.src = sources[0]; // reset to original image

    });

  });

});


document.addEventListener("DOMContentLoaded", function() {
    // Select all anchor links that start with #
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener("click", function(e) {
        // Prevent default jump behavior
        e.preventDefault();
        
        // Get the target section ID
        let targetId = this.getAttribute("href").substring(1);
        let targetElement = document.getElementById(targetId);

        // Smoothly scroll to the section if it exists
        if (targetElement) {
          window.scrollTo({
            top: targetElement.offsetTop - 50, // Adjust offset if needed
            behavior: "smooth"
          });
        }
      });
    });
  });

// Cart Button & Dessert Popup
document.addEventListener("DOMContentLoaded", function() {
  const cartLink = document.querySelector(".header .contents .items #cartlink");

  if (cartLink) {
    cartLink.addEventListener("click", function(event) {

      let canShow = true;
      const dessertShownTimestamp = localStorage.getItem('dessertShown');

      if (dessertShownTimestamp) {
        const elapsedTime = Date.now() - new Date(dessertShownTimestamp).getTime();
        // Check if at least 1 hour has passed
        if (elapsedTime < 3600000) {
          canShow = false;
        }
      }      

      if (window.innerWidth >= 1000 && hasDessert === false && window.location.pathname !== "/cart" && canShow) {
        event.preventDefault(); // Prevents following the link's href
        document.body.classList.add("modal", "modal-dessert");
        // Store the current timestamp as 'dessertShown'
        localStorage.setItem('dessertShown', new Date().toISOString());
      }
      // Otherwise, the click will work as usual.
    });
  }

  // Hide Dessert Popup
  
  document.addEventListener("click", function(event) {
    // No modal open → ignore
    if (!document.body.classList.contains("modal")) return;

    // Click inside ANY modal → ignore
    if (
      event.target.closest(".modal-try") ||
      event.target.closest(".modal-back-at-it")
    ) {
      return;
    }

    // Click on cart icon → ignore
    if (event.target.closest("#cartlink")) return;

    // Otherwise close whichever modal is open
    document.body.classList.remove(
      "modal",
      "modal-dessert",
      "modal-back"
    );
  });
  
});

// Luxury Sroll
document.addEventListener("DOMContentLoaded", function () {
    const navigateRight = document.querySelector(".luxury-promo .navigate .right");
    const listItems = document.querySelectorAll(".luxury-promo .contents > ul > li");

    if (navigateRight && listItems.length > 0) {
        let activeIndex = 0; // Start at the first item

        // Set the first item as active initially
        listItems[activeIndex].classList.add("active");

        navigateRight.addEventListener("click", function () {
            // Remove "active" class from current item
            listItems[activeIndex].classList.remove("active");

            // Move to the next item, or loop back to the start
            activeIndex = (activeIndex + 1) % listItems.length;

            // Add "active" class to the new item
            listItems[activeIndex].classList.add("active");
        });
    }
});

// Product Main Image Scroll
document.addEventListener("DOMContentLoaded", function () {
    // Select all product image thumbnails (assets)
    const thumbnails = document.querySelectorAll(".assets .product-images li");

    thumbnails.forEach(thumbnail => {
        thumbnail.addEventListener("click", function () {
            const selectedId = this.getAttribute("data-id"); // Get the clicked image's data-id

            // Select all main image list items
            const mainImages = document.querySelectorAll(".product .contents .left .image ul li");

            // Loop through and update classes
            mainImages.forEach(image => {
                if (image.getAttribute("data-id") === selectedId) {
                    image.classList.add("active");  // Add active class to the matching image
                } else {
                    image.classList.remove("active"); // Remove active class from others
                }
            });
        });
    });
});

// Product Accordion Toggle
document.addEventListener("DOMContentLoaded", function () {
    const listItems = document.querySelectorAll(".info ul li");

    listItems.forEach(li => {
        li.addEventListener("click", function () {
            const paragraph = this.querySelector("p");
            const span = this.querySelector("span");
            const ul = this.querySelector("ul.nutrition-table");

            // Toggle 'active' class on both <p> and <span>
            if(paragraph){paragraph.classList.toggle("active");}
            span.classList.toggle("active");
            ul.classList.toggle("active");

            // Optional: Hide other <p> tags and remove 'active' from other spans (Accordion Effect)
            listItems.forEach(item => {
                if (item !== this) {
                    item.querySelector("p").classList.remove("active");
                    item.querySelector("ul.nutrition-table").classList.remove("active");
                    item.querySelector("span").classList.remove("active");
                }
            });
        });
    });
});

// Extended Description
document.addEventListener("DOMContentLoaded", function () {
  const desc = document.querySelector(".product .contents .right .description");
  const extended = document.querySelector(".product .contents .right .extended");

  if (desc && extended) {
    desc.addEventListener("click", function () {
      desc.classList.toggle("active");
      extended.classList.toggle("active");
    });
  }
});

// Basket Hover
document.addEventListener("DOMContentLoaded", function () {
    let basket = document.querySelector(".header .basket");
    let volume = document.querySelector(".header .basket .volume");
    let value = document.querySelector(".header .basket .value");

    if (basket && volume && value) {
        basket.addEventListener("mouseover", function () {
            volume.style.display = "none";
            value.style.display = "flex";
        });

        basket.addEventListener("mouseout", function () {
            volume.style.display = "flex";
            value.style.display = "none";
        });
    }
});

// Index - Collection Switch
document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".product-grid#start .contents .header ul li").forEach(li => {
        li.addEventListener("click", async function () {

            // Get collection handle from data-collection attribute
            let collectionUrl = this.getAttribute("data-collection");
            if (!collectionUrl) return;

            // Remove 'active' class from all and add to the clicked one
            document.querySelectorAll(".product-grid#start .contents .header ul li").forEach(el => el.classList.remove("active"));
            this.classList.add("active");

            try {
                let currentProductsList = document.querySelector(".product-grid#start .contents .products ul");
                currentProductsList.classList.add("updating");
              
                // Fetch the Shopify collection page asynchronously
                let response = await fetch("/collections/" + collectionUrl);
                if (!response.ok) throw new Error(`Failed to load collection: ${response.statusText}`);

                let html = await response.text();

                // Create a temporary container to parse the fetched HTML
                let tempDiv = document.createElement("div");
                tempDiv.innerHTML = html;

                // Extract the new .product-grid#start .contents .products ul
                let newProductsList = tempDiv.querySelector(".product-grid#start .contents .products ul");
                if (!newProductsList) throw new Error("Could not find .product-grid#start .contents .products ul in the fetched content");
                newProductsList.classList.add("updating");
              
                // Replace the current products list with the new one
                
                if (currentProductsList) {
                    currentProductsList.replaceWith(newProductsList);
                    newProductsList.classList.remove("updating");
                    initialiseCartButtons(".product-grid#start");
                    Cart.getCart().then(cart => Cart.updateUI(cart));
                }

                console.log("Collection loaded successfully:", collectionUrl);
            } catch (error) {
                console.error("Error loading collection:", error);
            }
        });
    });
});

// Collection - Collection Switch
document.addEventListener("DOMContentLoaded", function () {
  const parentSelector = document.querySelector(".product-grid#start .contents .header > .selector");
  if (parentSelector) {
    parentSelector.addEventListener('click', function() {
      const nestedUl = this.querySelector('ul.selector');
      if (nestedUl) {
        nestedUl.classList.add('active');
      }
    });
  }

  // Checkout Postcode Check
  const postcodeInput = document.querySelector("input#cart_postcode");
  if (postcodeInput) {
      postcodeInput.addEventListener('input', function() {
        let val = this.value.replace(/\D/g, '');
        val = val.slice(0, 4);
        this.value = val;
      });
  }

  // Choose Delivery Day
  const labelEl = document.querySelector('#cart_available_days label');
  const ulEl    = document.querySelector('#cart_available_days ul');

  if (labelEl && ulEl) {
    labelEl.addEventListener('click', function() {
      ulEl.classList.add('active');
    });
  }  

  // Cart Note Order Attribute
  
  const instructionsTextarea = document.getElementById('cart_instructions');
  if(instructionsTextarea){
      instructionsTextarea.addEventListener('blur', function() {
        const noteValue = instructionsTextarea.value;
    
        // Update the cart note via Shopify's AJAX endpoint
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            note: noteValue
          })
        })
          .then(response => response.json())
          .then(data => {
            console.log('Cart note updated:', data.note);
          })
          .catch(error => {
            console.error('Error updating cart note:', error);
          });
      });
  }

  //Hamburger Menu
  const hamburgerMenu = document.getElementById('menu_hamburger');
  if(hamburgerMenu){
    hamburgerMenu.addEventListener('click', function() {
      this.classList.toggle('active');
      const navElement = document.querySelector('.header .contents > .navigation');
      if (navElement) {
        navElement.classList.toggle('active');
      }
    });
  }

  // Submit Promo Form
  const promoForm = document.getElementById('promo-form');
  const promoContent = document.getElementById('promo-content');

  if (promoForm) {

      // STEP A — Capture ?ref=XXX and store in hidden field
      const params = new URLSearchParams(window.location.search);
      const ref = params.get("ref");
      if (ref) {
          const referredField = document.getElementById("referred_by");
          if (referredField) referredField.value = ref;
      }

      promoForm.addEventListener('submit', async function(event) {
          event.preventDefault();

          try {
              // STEP B — Generate referral code before JSON
              const email = document.getElementById("emailaddress").value;
              const firstname = document.getElementById("firstname").value;
              const referralCode = await generateReferralCode(email, firstname);
              document.getElementById("referral_code").value = referralCode;

              // STEP C — Build JSON body
              const formData = new FormData(promoForm);
              const data = {};
              formData.forEach((v, k) => data[k] = v);
              const jsonData = JSON.stringify(data);

              // STEP D — Send to Zapier (no-cors = always resolves)
              await fetch(promoForm.action, {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: jsonData,
                  mode: 'no-cors'
              });

              // STEP E — Build Thank You Message FIRST
              const successHTML = `
                <h2>Thank you for entering the competition!</h2>
                <p>You’re now in the draw to win the air fryer.</p>

                <div style="margin-top:20px; display: flex; width:100%; align-items: center;">
                  <h3>Boost your chances!</h3>
                  <p>Share this competition. For <strong>every person who enters</strong> via your link, you’ll receive <strong>3 bonus entries</strong>.</p>
                </div>

                <div id="share-area" style="margin:20px 0; text-align:center;">
                  <button id="share-btn" 
                    style="background:#130944; color:#fff; border:none; padding:12px 20px; border-radius:6px; cursor:pointer; font-size:16px;">
                    Share Competition
                  </button>

                  <div style="margin-top:15px;">
                    <p style="font-size:14px; margin-bottom:8px;">Or copy your link:</p>
                    <input id="share-link" type="text" readonly 
                      style="width:calc(100%-20px); padding:10px; border:1px solid #ddd; border-radius:6px; font-size:14px; text-align:center;">
                    <button id="copy-btn" 
                      style="margin-top:10px; background:#C49A6C; color:#fff; padding:8px 16px; border:none; border-radius:6px; cursor:pointer;">
                      Copy Link
                    </button>
                  </div>
                </div>
              `;
              window.scrollTo({ top: 180, behavior: 'smooth' });

              // Insert thank you
              promoForm.innerHTML = successHTML;
              if (promoContent) promoContent.remove();

              // STEP F — SAFELY init share link AFTER HTML exists
              const shareUrl = `https://yeschefmeals.com.au/pages/airfryer?ref=${referralCode}`;
              document.getElementById("share-link").value = shareUrl;

              // Native Share
              document.getElementById("share-btn").addEventListener("click", async () => {
                  if (navigator.share) {
                      await navigator.share({
                          title: "Win an Air Fryer with Yes Chef Meals!",
                          text: "Enter using my link — plus you’ll give me bonus entries!",
                          url: shareUrl
                      });
                  } else {
                      alert("Sharing not supported on this device. Please copy the link below.");
                  }
              });

              // Copy Link
              document.getElementById("copy-btn").addEventListener("click", () => {
                  navigator.clipboard.writeText(shareUrl);
                  document.getElementById("copy-btn").innerText = "Copied!";
                  setTimeout(() => {
                      document.getElementById("copy-btn").innerText = "Copy Link";
                  }, 1500);
              });

          } catch (error) {
              console.error("Form submission error:", error);
              promoForm.insertAdjacentHTML(
                  'afterbegin',
                  '<p>There was an error submitting the form. Please try again later.</p>'
              );
          }
      });
  }
 
});

// Checkout Check
document.addEventListener('DOMContentLoaded', function () {
  const checkoutButton = document.querySelector('#payment-checkout-action');
  
  if (checkoutButton) {
    checkoutButton.addEventListener('click', function (e) {
      e.preventDefault();

      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          const deliveryDate = cart.attributes && cart.attributes['Delivery Date'];
          const cartTotal = cart.total_price / 100; // Shopify returns in cents

          if (!deliveryDate) {
            checkoutButton.textContent = 'Choose a Delivery Date';
            checkoutButton.classList.add('warning');
          } else if (cartTotal < 30) {
            checkoutButton.textContent = 'Minimum order of $30 applies';
            checkoutButton.classList.add('warning');
          } else {
            window.location.href = '/checkout';
          }
        })
        .catch(error => {
          console.error('Error fetching cart:', error);
        });
    });
  }
});

// Update Delivery Day Selection
function updateShopifyCartWithDeliveryDate(deliveryDate) {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: {
          "Delivery Date": deliveryDate
        }
      })
    })
      .then(response => response.json())
      .then(data => {
        console.log('Cart updated with Delivery Date:', data.attributes['Delivery Date']);

        const checkoutButton = document.querySelector('#payment-checkout-action');
        if (checkoutButton) {
            checkoutButton.textContent = 'Proceed to Payment';
            checkoutButton.classList.remove('warning');
        }
        
      })
      .catch(error => {
        console.error('Error updating cart note:', error);
      });
  }  

function setDeliveryDateFromLabel() {
    const labelElem = document.querySelector('#cart_available_days > label');
    if (!labelElem) {
      console.error('Could not find #cart_available_days > label element.');
      return;
    }
  
    const rawDateText = labelElem.innerHTML.trim(); // e.g. "Saturday, 22nd March 2025"
    const formattedDate = formatDateFromLabel(rawDateText);
    if (formattedDate) {
      updateShopifyCartWithDeliveryDate(formattedDate);
    }
  }

// Track Dessert Added
var hasDessert = false;

// Functions Referral
async function sha256(message) {
    const msgBuffer = new TextEncoder().encode(message);
    const hashBuffer = await crypto.subtle.digest("SHA-256", msgBuffer);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
}

function encodeReferral(str) {
    return btoa(str).replace(/[^a-zA-Z0-9]/g, '').substring(0, 10);
}

async function generateReferralCode(email, firstname) {
    const input = (email + firstname).toLowerCase().trim();
    const hash = await sha256(input);
    return encodeReferral(hash);
}


// Back At It Freebie – Cart Logic

const BACK_AT_IT_FIXED = [
  47468535218341, // Peanut Butter & Coconut Protein Bar (FREE)
  47468535054501  // Choc Chip Cookie Dough Protein Bar (FREE)
];

const BACK_AT_IT_CHOICES = [
  47468535480485, // Bircher Muesli with Spiced Apple & House Granola (FREE)
  47468535578789  // Tiramisu Overnight Oats (FREE)
];

document.addEventListener("DOMContentLoaded", function () {

  if (window.location.pathname !== "/cart") return;

  const FIXED_VARIANTS = [
    47468535218341,
    47468535054501
  ];

  const CHOICE_VARIANTS = [
    47468535480485, 
    47468535578789 
  ];

  function cartHasBackAtIt(cart) {
    return cart.items.some(item =>
      item.properties &&
      item.properties["_back_at_it"] === "true"
    );
  }

  function showBackAtItModal() {
    document.body.classList.add("modal", "modal-back");
    document.querySelector(".modal-back-at-it")?.classList.add("active");
  }
  
  function hideBackAtItModal() {
    document.body.classList.remove("modal", "modal-back");
    document.querySelector(".modal-back-at-it")?.classList.remove("active");
  }

  function maybeTriggerBackAtIt(cart) {
    const subtotal = cart.original_total_price / 100;

    if (subtotal < 100) return;
    if (cartHasBackAtIt(cart)) return;

    showBackAtItModal();
  }

  function addBackAtIt(choiceVariantId) {

    const items = [
      {
        id: FIXED_VARIANTS[0],
        quantity: 1,
        properties: { "_back_at_it": "true" }
      },
      {
        id: FIXED_VARIANTS[1],
        quantity: 1,
        properties: { "_back_at_it": "true" }
      },
      {
        id: choiceVariantId,
        quantity: 1,
        properties: { "_back_at_it": "true" }
      }
    ];

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items })
    })
      .then(() => fetch("/cart.js"))
      .then(res => res.json())
      .then(cart => {
        hideBackAtItModal();
        window.location.reload();
      })
      .catch(err => console.error("Back At It add error:", err));
  }

  // Initial cart check
  fetch("/cart.js")
    .then(res => res.json())
    .then(cart => maybeTriggerBackAtIt(cart));

  // Add button handler
  document.addEventListener("click", function (e) {
    if (e.target.id !== "back-at-it-add") return;

    const selected = document.querySelector(
      'input[name="back-at-it-choice"]:checked'
    );

    if (!selected) {
      alert("Please choose one breakfast option 🙂");
      return;
    }

    addBackAtIt(parseInt(selected.value, 10));
  });

  // Close modal when clicking outside
  document.addEventListener("click", function (e) {
    if (!document.body.classList.contains("modal")) return;
    if (e.target.closest(".modal-back-at-it")) return;

    hideBackAtItModal();
  });

});

document.addEventListener("DOMContentLoaded", function () {

  if (window.location.pathname !== "/cart") return;

  function removeBackAtItFreebies(cart) {

    const updates = {};

    cart.items.forEach(item => {
      if (
        item.properties &&
        item.properties["_back_at_it"] === "true"
      ) {
        updates[item.key] = 0;
      }
    });

    // Nothing to remove
    if (Object.keys(updates).length === 0) return;

    fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ updates })
    })
      .then(() => fetch("/cart.js"))
      .then(res => res.json())
      .then(updatedCart => {
        if (typeof Cart !== "undefined" && Cart.updateUI) {
          Cart.updateUI(updatedCart);
        }
      })
      .catch(err => console.error("Back At It removal error:", err));
  }

  // Check on page load
  fetch("/cart.js")
    .then(res => res.json())
    .then(cart => {
      const subtotal = cart.original_total_price / 100;

      if (subtotal < 100) {
        removeBackAtItFreebies(cart);
      }
    });

});